<template>
    <div>
        <el-dialog v-if="dialogFormVisible" v-el-drag-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :width="'800px'" :title="$tx('gwgl.components.fileSettings', '归档文件设置')">
            <el-form ref="elform">
                <div class="el-table el-table--fit el-table--border" style="100%;height:276px">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body el-table__body-no">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'categoryName'">归档分类</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="分类" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input ref="gdTypeTree" v-model="vo.categoryName" v-select-dialog="'gdtype'" :init-tree-data="treeData" style="width: 100%" :dialog-title="$tx('gwgl.components.archiveClassificationSelect', '选择归档分类')" :multiple="false" :placeholder="$tx('gwgl.components.archiveClassificationPlaceholder', '请选择归档分类')" name="" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'gdType'">归档类型</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider v-if="gdTypeEdit" ref="ValidationProvider" v-slot="{ errors }" name="归档类型" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-select v-model="vo.gdType" :placeholder="$tx('gwgl.components.archivedTypePlaceholder')" style="width: 100%">
                                                    <el-option v-for="item in gdType" :key="item.value" :label="item.title" :value="item.value" />
                                                </el-select>
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <div v-else>{{ gdTypeObj[vo.gdType] }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td v-field-lbl="'accessRightsType'" class="el-table__cell tdlbl tdw17">文件查阅权限</td>
                                    <td colspan="5" class="el-table__cell tdcont tdw83">
                                        <el-radio-group v-model="vo.accessRightsType">
                                            <el-radio v-text-lbl="'allPersonnel'" :label="0">全体人员可阅</el-radio>
                                            <el-radio v-if="vo.busiDataId" v-text-lbl="'originalHandler'" :label="1">原经办人可阅</el-radio>
                                            <el-radio v-if="vo.busiDataId" v-text-lbl="'handlerDesignated'" :label="2">原经办人+指定人可阅</el-radio>
                                            <el-radio v-if="!vo.busiDataId" v-text-lbl="'designatedReaders'" :label="2">指定可阅人</el-radio>
                                        </el-radio-group>
                                    </td>
                                </tr>
                                <tr v-if="vo.accessRightsType === 2">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'appoints'">指定类型</span>
                                    </td>
                                    <td colspan="5" class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="指定类型" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="vo.appoints" @change="changAppoints">
                                                    <el-radio v-text-lbl="'specifyGroup'" :label="'1'">指定群组</el-radio>
                                                    <el-radio v-text-lbl="'specifyDepart'" :label="'2'">指定部门</el-radio>
                                                    <el-radio v-text-lbl="'specifyPerson'" :label="'3'">指定人员</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="vo.accessRightsType === 2 && vo.appoints !== '' && vo.appoints !== null">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-if="vo.appoints === '1'" v-text-lbl="'selectGroup'">选择群组</span>
                                        <span v-if="vo.appoints === '2'" v-text-lbl="'selectDepart'">选择部门</span>
                                        <span v-if="vo.appoints === '3'" v-text-lbl="'selectPerson'">选择人员</span>
                                    </td>
                                    <td colspan="5" class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="群组" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="vo.appoints === '1'" v-model="vo.deptOrName" v-select-dialog="'workgroup'" :placeholder="$tx('gwgl.components.GroupPlaceholder', '请选择群组')" readonly="readonly" multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds2" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="vo.appoints === '2'" v-model="vo.deptOrName" v-select-dialog="'suborg'" :placeholder="$tx('gwgl.components.DepartPlaceholder', '请选择部门')" org-level="2" readonly="readonly" multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="vo.appoints === '3'" v-model="vo.deptOrName" v-select-dialog="'staff'" :placeholder="$tx('gwgl.components.PersonPlaceholder', '请选择人员')" readonly="readonly" multiple="true" type="textarea" name="deptIds" :root-org-code="vo.orgCode" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button v-for="(btn, key) in busiformBtns" :key="key" :disabled="doing" :loading="btn.btnIcon === 'check' ? btnLoading : false" :plain="btn.btnType === null || btn.btnType === ''" :icon="'el-icon-' + btn.btnIcon" :type="btn.btnType !== null ? btn.btnType : ''" @click="btn.btnClick">{{ btn.btnName }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'components',
            btnLoading: false,
            title: '',
            rowsSelected: [],
            vo: {
                categoryName: '', // 分类
                categoryId: '', // 分类id
                accessRightsType: 0, // 文件查阅权限
                appoints: '1', // 指定类型
                deptOrName: '', // 群组名称
                deptIds: '', // 群组id
                status: 8, // 状态 归档
                flGwType: '', // 公文类型
                busiDataId: null,
                gdType: null // 归档类型
            },
            dialogFormVisible: false,
            doing: false,
            root: [
                // { id: '1', parentId: '0', name: '归档文件', categoryName: '归档文件', open: true, title: '归档文件' }
            ],
            treeData: [],
            busiformBtns: [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: this.closeDialog,
                    btnPermission: '',
                    btnType: ''
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: this.submitSave,
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ],
            gwType: {
                wjcy: this.$tx('gwgl.portlet.documentCirculation', '文件传阅'),
                bmbh: this.$tx('gwgl.portlet.departmentalLetter', '部门便函'),
                yjzj: this.$tx('gwgl.portlet.solicitationOpinions', '意见征集'),
                hytz: this.$tx('gwgl.portlet.hytz', '会议通知'),
                qsbg: this.$tx('gwgl.portlet.requestInstructions', '请示报告'),
                dzgg: this.$tx('gwgl.portlet.dzgg', '电子公告')
            },

            // gdType: [{ title: '电子归档', value: 1 }, { title: '纸质归档', value: 2 }],
            gdType: [
                { title: this.$tx('gwgl.components.electronicFilling', '电子归档'), value: 1 },
                { title: this.$tx('gwgl.components.paperArchiving', '纸质归档'), value: 2 }
            ],
            // gdTypeObj: { 1: '电子归档', 2: '纸质归档' },
            gdTypeObj: { 1: this.$tx('gwgl.components.electronicFilling', '电子归档'), 2: this.$tx('gwgl.components.paperArchiving', '纸质归档') },
            updateUrl: '',
            edit: false,
            code: '',
            loginUser: this.$store.getters.loginUser,
            gdTypeEdit: true
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openDialog', this.openDialog)
        this.queryData()
    },
    beforeDestroy() {
        this.$bus.on('openDialog', this.openDialog)
    },
    mounted() {},
    methods: {
        openDialog(data) {
            this.gdTypeEdit = true
            if (data.rowsSelected.length < 1) {
                this.$alert(this.$tx('gwgl.messages.selectFile', '请选择需要归档的文件！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return
            }
            if (data.rowsSelected[0].wfNodeNames) {
                this.vo.busiDataId = data.rowsSelected[0].id
            } else {
                this.vo.busiDataId = data.rowsSelected[0].busiDataId
            }
            if (data.edit) {
                this.edit = true
                this.updateUrl = '/gwgl/gdwj/updateList'
                //  categoryName: '', // 分类
                //   accessRightsType: 0, // 文件查阅权限
                //   appoints: '1', // 指定类型
                //   deptOrName: '', // 群组名称
                //   deptIds: '', // 群组id
                //   status: 8, // 状态 归档
                //   flGwType: '' // 公文类型
                this.vo.categoryName = data.rowsSelected[0].categoryName
                this.vo.categoryId = data.rowsSelected[0].categoryId
                this.vo.accessRightsType = data.rowsSelected[0].accessRightsType
                this.vo.appoints = data.rowsSelected[0].appoints
                this.vo.deptOrName = data.rowsSelected[0].deptOrName
                this.vo.deptIds = data.rowsSelected[0].deptIds
                this.vo.status = data.rowsSelected[0].status
                this.vo.flGwType = data.rowsSelected[0].flGwType
                this.vo.gdType = data.rowsSelected[0].gdType
            } else {
                this.updateUrl = data.url
                this.code = data.url.split('/')[1]
                this.vo.gdType = data.gdtype ? 1 : data.rowsSelected[0].gdType || 1
                this.gdTypeEdit = false
            }
            this.rowsSelected = data.rowsSelected
            this.dialogFormVisible = true
        },
        async submitSave() {
            this.btnLoading = true
            this.$refs.elform.formValidate(() => {
                if (!this.vo.categoryName) {
                    this.$alert(this.$tx('gwgl.messages.selectArchiveClassification', '请选择归档分类！'), this.$tx('common.operationTip', '操作提示'), {
                        confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                        type: 'warning'
                    })
                    this.btnLoading = false
                    return
                }
                if (!this.vo.gdType) {
                    this.$alert(this.$tx('gwgl.messages.selectArchivedType'), this.$tx('common.operationTip', '操作提示'), {
                        confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                        type: 'warning'
                    })
                    this.btnLoading = false
                    return
                }
                if (this.edit) {
                    this.rowsSelected.forEach((item) => {
                        item.categoryName = this.vo.categoryName
                        item.categoryId = this.vo.categoryId
                        item.accessRightsType = this.vo.accessRightsType
                        item.appoints = this.vo.appoints
                        item.deptOrName = this.vo.deptOrName
                        item.deptIds = this.vo.deptIds
                        item.status = this.vo.status
                        // item.flGwType = this.vo.flGwType
                        item.gdType = this.vo.gdType
                    })
                    this.updateHandler()
                } else {
                    const list = []
                    this.rowsSelected.forEach((item) => {
                        if (this.code === 'fawen') {
                            this.vo.flGwType = item.flType
                        } else if (this.code === 'shouwen') {
                            if (item.flLwdwCode && item.flLwdwCode !== item.orgCode) {
                                this.vo.flGwType = item.flType
                            } else if (item.flSwzh) {
                                this.vo.flGwType = this.$tx('gwgl.portlet.readingOffice', '收文阅办')
                            } else if (!item.flSwzh) {
                                this.vo.flGwType = this.$tx('gwgl.portlet.receiptDocuments', '部门收文')
                            }
                        } else {
                            this.vo.flGwType = this.gwType[this.code]
                        }
                        this.vo.busiDataId = item.id
                        const newObj = Object.assign(item, this.vo)
                        delete newObj.id
                        list.push(newObj)
                    })
                    this.submitSaveHandler(list)
                }
            })
        },
        async updateHandler() {
            const vobak = JSON.parse(JSON.stringify(this.rowsSelected))
            const res = await this.$app.update(this.updateUrl, vobak)
            if (res.code === 'success') {
                this.$bus.emit('refreshListData')
                this.closeDialog()
                this.$message({ message: res.message, type: 'success' })
                this.btnLoading = false
            } else {
                this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                this.btnLoading = false
            }
        },
        async submitSaveHandler(list) {
            const vobak = JSON.parse(JSON.stringify(list))
            const res = await this.$app.insert('/gwgl/gdwj/insertList?module=' + this.code, vobak)
            if (res.code === 'success') {
                this.$bus.emit('refreshListData')
                this.closeDialog()
                this.$message({ message: res.message, type: 'success' })
                this.btnLoading = false
            } else {
                this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                this.btnLoading = false
            }
        },
        closeDialog() {
            this.title = ''
            this.doing = false
            this.rowsSelected = []
            this.vo = {
                categoryName: '', // 分类
                categoryId: '',
                accessRightsType: 0, // 文件查阅权限
                appoints: '1', // 指定类型
                deptOrName: '', // 群组名称
                deptIds: '', // 群组id
                status: 8 // 状态 归档
            }
            this.dialogFormVisible = false
        },
        queryData() {
            // 加载类型节点数据
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'categoryLevel asc,orderno asc' },
                data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                url: '/gwgl/gdflsz/querydata'
            }).then((res) => {
                if (res.code === 'success') {
                    this.treeData = this.treeData = this.treeDataAdapter(this.root.concat(res.body.listdata))
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (node.parentId === null || node.parentId === '' || node.parentId === undefined) {
                    node.pId = '1'
                } else {
                    node.pId = node.parentId
                }
                node.name = node.categoryName
                node.title = node.categoryName
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        // 选择归档分类
        onGdtypeCompleted(selectedNodes, attr) {
            this.vo.categoryName = selectedNodes[0].name
            this.vo.categoryId = selectedNodes[0].categoryFullId
        },
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this.vo, 'deptIds', selectCode)
            this.$set(this.vo, 'deptOrName', selected)
        },
        // 选择工作群组
        onSelectWorkgroupCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this.vo, 'deptIds', selectCode)
            this.$set(this.vo, 'deptOrName', selected)
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selectCode += '、'
                if (selected !== '') selected += '、'
                selected += node.name
                selectCode += node.personId
            })

            this.$set(this.vo, 'deptOrName', selected)
            this.$set(this.vo, 'deptIds', selectCode)
        },
        // 切换选项清空
        changAppoints(value) {
            this.vo.deptIds = ''
            this.vo.deptOrName = ''
            if (value === this.activeId) {
                this.vo.deptIds = this.activedeptIds
                this.vo.deptOrName = this.activeText
            }
        }
    }
}
</script>

<style scoped lang="scss">
.el-table__body {
    &.el-table__body-no {
        table-layout: auto;
    }
}
</style>
